import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import { history } from '../../_helpers'
import Select from 'react-select';
import './SignIn.scss'
import { fieldOptions, 
  // SMjobOptions, freshOptions, schoolOptions, majorOptions, abilityOptions, interestOptions, 
  tagOptions, nationOptios } from './data';
import {UserContext} from "../../context/context"
import {Link} from 'react-router-dom';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';


function ComSignIn(props) {
  // const [data, setData] = useState(null)

  const [state, actions] = useContext(UserContext);
  
  const [page, setPage] = useState(0)

  const [title, setTitle] = useState()
  // const [intro, setIntro] = useState()
  const [address, setAddress] = useState()
  const [homepage, setHomepage] = useState()
  const [tag, setTag] = useState([])

  const [nation, setNation] = useState(nationOptios[0].value)
  const [year, setYear] = useState() //From here, need to add models.py and edit views.py
  const [field, setField] = useState()
  const [comNumber, setComNumber] = useState()
  const [revenue, setRevenue] = useState()
  const [investment, setInvestment] = useState()
  const [people, setPeople] = useState()
  const [phone, setPhone] = useState()

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorState) => {
      // editorState에 값 설정
      setEditorState(editorState);
    };


  let user = JSON.parse(String(localStorage.getItem('user')))
  
  const header = {
    'Authorization': `JWT ${user.token}`,
    // 'Authorization': `JWT ${state.token}`,
    'Content-Type': 'application/json'
  }



  useEffect(()=>{
    async function fetchAllData(){
      fetch(state.awslink + "/user/alldata/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        if(json.is_headhunter || json.is_recruiter){
          if(json.is_headhunter){
            history.push('/recruiter')
          }
          else if(json.is_recruiter){
            if(json["company#"] === 0){
              setPage(1)
            }
            else{
              history.push('/recruiter')
            }
          }
        }
        
        else{
          setPage(0)
        }
      })   
    }

    fetchAllData()
    
  }, [])

  

  function fetchPage0(index){
    // console.log(field, job, fresh)
    if(index === "is_headhunter")
      localStorage.setItem('is_headhunter', true)
    else
      localStorage.setItem('is_recruiter', true)
    fetch(state.awslink + "/user/whoru/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        [index]: true
      })
    })
    .then(response => response.json())
    .then(json=>{
      if(index === "is_headhunter"){
        history.push('/recruiter');
      }
    })
  }

  function fetchPage1(index){
    // console.log(index, title, major, paper, startY, startM, endY, endM)
    fetch(state.awslink + "/user/company/", {
      method: 'POST',
      headers: header,
      body:JSON.stringify({
        "title": title || null,
        "intro": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
        "address": address || null,
        "homepage": homepage || null,
        "tag": tag || null,
        "nation": nation || null,
        "comNumber": comNumber || null,
        "revenue": revenue || null,
        "investment": investment || null,
        "people": people || null,
        "phone": phone || null,
        "field": field || null,
        "year": year || null,
      })
    })
    .then(response => response.json())
    .then(json=>{})
  }

//   function fetchPage2(){
//     console.log(abilities, interests, tag)
//     fetch(state.awslink  + "/user/userIntAbi/", {
//       method: 'POST',
//       headers: header,
//       body:JSON.stringify({
//         "abilities": abilities,
//         "interests": interests,
//         "tag": tag,
//       })
//     })
//     .then(response => response.json())
//     .then(json=>{})
//   }


  const handleChange = (nameTag) => e => {
    // if(nameTag === "ab") setAbilities(Array.isArray(e) ? e.map(x => x.value) : []);
    // else if(nameTag === "int") setInterests(Array.isArray(e) ? e.map(x => x.value) : []);
    if(nameTag === "tag") setTag(Array.isArray(e) ? e.map(x => x.value) : []);
  }

  // console.log(abilities)

  return(
    <Wrapper>
      <SignInWrapper>
        

        {/* Basic info */}
        {page === 0 && 
        <>
        <Link to={'/'}>홈으로</Link>
          <SignInForm>
            <button onClick={()=>{fetchPage0("is_headhunter")}}>
                헤드헌터
            </button>
            <button disabled onClick={()=>{setPage(page+1);fetchPage0("is_recruiter")}}>
                리크루터
            </button>
          </SignInForm>
        </>
        }

        {page === 1 && 
        <>
        
        
          <SignInFormLot>
            <span>
              <div>
                TITLE
                <input className="basic-input" value={title} onChange={(e)=>setTitle(e.target.value)}/>
              </div>
              <div>
                ADDRESS
                <input className="basic-input" value={address} onChange={(e)=>setAddress(e.target.value)}/>
              </div>
            </span>

            <span>
              <div>
                NATION
                <Select
                  className="basic-single"
                  defaultValue={nationOptios[0]}
                  isSearchable={true}
                  name="color"
                  options={nationOptios}
                  onChange={(e)=>{if(e.value) setNation(e.value)}}
                />
              </div>
              <div>
                FIELD
                <Select
                  className="basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={fieldOptions}
                  onChange={(e)=>{if(e.value) setField(e.value)}}
                />
              </div>
            </span>

            <span>
              <div>
                HOMPAGE
                <input className="basic-input" value={homepage} onChange={(e)=>setHomepage(e.target.value)}/>
              </div>
              <div>
                COMPANY NUMBER
                <input className="basic-input" value={comNumber} onChange={(e)=>setComNumber(e.target.value)}/>
              </div>
            </span>
            
            
            <span>
              <div>
                REVENUE
                <input className="basic-input" value={revenue} onChange={(e)=>setRevenue(e.target.value)}/>
              </div>
              <div>
                INVESTMENT
                <input className="basic-input" value={investment} onChange={(e)=>setInvestment(e.target.value)}/>
              </div>
            </span>

            <span>
              <div>
                PEOPLE
                <input className="basic-input" value={people} onChange={(e)=>setPeople(e.target.value)}/>
              </div>
              <div>
                PHONE
                <input className="basic-input" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
              </div>
            </span>

            <span>
              <div>
                YEAR
                <input className="basic-input" value={year} onChange={(e)=>setYear(e.target.value)}/>
              </div>
            </span>
            TAG
            <Select
              defaultValue={null}
              className="basic-multi"
              isMulti
              options={tagOptions}
              onChange={handleChange("tag")}
            />
            
            INTRO
            <Editor
              // 에디터와 툴바 모두에 적용되는 클래스
              wrapperClassName="wrapper-class"
              // 에디터 주변에 적용된 클래스
              editorClassName="editor"
              // 툴바 주위에 적용된 클래스
              toolbarClassName="toolbar-class"
              // 툴바 설정
              toolbar={{
                // inDropdown: 해당 항목과 관련된 항목을 드롭다운으로 나타낼것인지
                list: { inDropdown: true },
                textAlign: { inDropdown: true },
                link: { inDropdown: true },
                history: { inDropdown: false },
              }} 
              placeholder="내용을 작성해주세요."
              // 한국어 설정
              localization={{
                locale: 'ko',
              }}
              // 초기값 설정
              editorState={editorState}
              // 에디터의 값이 변경될 때마다 onEditorStateChange 호출
              onEditorStateChange={onEditorStateChange}
            />
            

          </SignInFormLot>
            <button onClick={()=>{
              fetchPage1();
              history.push('/recruiter/profile');
            }}
            >
              다음
            </button>
            <Link to={'/recruiter'}>
              나중에 하기
            </Link>
        </>
        }

        
        {/* <Link to={'/recruiter'}>
          나중에 하기
        </Link> */}
      </SignInWrapper>
    </Wrapper>   
  )
}

export default ComSignIn;

const Wrapper = styled.div`
  display: flex;
  /* width: 100vw;
  min-height: 100vh;
  height: 100%; */
  justify-content: center;
  align-items: center;
  overflow:overlay; 

  background-color: rgba(0,0,0,0.1);
`
const SignInWrapper = styled.div`
  display: flex;
  width: 80vw;
  /* height: 100%; */
  min-height: 90vh;
  position: absolute;
  top: 5vh;
  justify-content: flex-start;
  align-items: center;

  background-color: white;
  border-radius: 5px;

  flex-direction: column;

  /* border: red solid; */
`
const SignInForm = styled.div`
  display: flex;
  width: 100%;
  min-width: 100%;
  height: 490px;

  
  
  justify-content: center;
  align-items: center;

  background-color: white;
  border-radius: 5px;

  flex-direction: column;

  
`

const SignInFormLot = styled.div`
/* border: green solid; */
  display: flex;
  width: calc(100% - 20px);
  /* min-width: 100%; */
  height: calc(100% - 20px);
  
  justify-content: flex-start;
  align-items: flex-start;

  /* top: 10vh; */
  padding: 10px;

  background-color: white;
  
  border-radius: 5px;

  flex-direction: column;

  > span{
    /* background-color: red; */
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    margin-bottom: 5px;
    > div{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      :last-child{
        position: absolute;
        left: 50%;
      }
      
    }
  }
`

// const YearWrapper=styled.div`
//   display: flex;
//   flex-direction: row;
// `